// Supabase client will be injected by each app
export let supabase = null;
// Function to set the Supabase client from each app
export const setSupabaseClient = (client) => {
    supabase = client;
};
